import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoGearMiningLogListRequest,
  LogControllerDtoGearMiningLogListResponse,
  PerplayLogApi
} from '../../models/src';
import { GEAR_MINING_LOG_LIST_REQUEST } from '../../constants/log/gearMiningLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new PerplayLogApi(config.API_CLIENT);

function* gearMiningLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoGearMiningLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.postNo = payload.postNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogGearMiningLogListPost({ logControllerDtoGearMiningLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoGearMiningLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}
function* gearMiningLogRootSaga() {
  yield all([
    takeEvery(GEAR_MINING_LOG_LIST_REQUEST, gearMiningLogListRequestSaga),
  ])
}

const gearMiningLogSaga = [
  fork(gearMiningLogRootSaga),
]

export default gearMiningLogSaga;
